import React from 'react';

export default function Depoimentos() {
  return(
    <h2>Depoimentos</h2>
  ) 
}
